export const products = [
  { id: 1, brand: 'Rolex', title: 'Day-Date Gold', category: 'Rolex', image: '/watch-1.png' },
  { id: 2, brand: 'Patek Philippe', title: 'Nautilus Silver', category: 'Patek Philippe', image: '/watch-2.png' },
  { id: 3, brand: 'Cartier', title: 'Tank Leather', category: 'Cartier', image: '/watch-3.png' },
  {
    id: 7,
    brand: 'Cartier',
    title: 'SANTOS DE CARTIER',
    category: 'Cartier',
    image: '/santos-de-cartier.jpg',
    description: {
      tr: 'İkonik Cartier koleksiyonunun en eşsiz parçalarından biri.',
      en: 'One of the most distinctive pieces in the iconic Cartier collection.',
      de: 'Eines der einzigartigsten Stücke der ikonischen Cartier-Kollektion.',
    },
  },
  { id: 4, brand: 'Rolex', title: 'Submariner Date', category: 'Rolex', image: '/watch-1.png' },
  { id: 5, brand: 'Audemars Piguet', title: 'Royal Oak Off.', category: 'Audemars Piguet', image: '/watch-2.png' },
  { id: 6, brand: 'Rolex', title: 'GMT-Master II', category: 'Rolex', image: '/watch-1.png' },
]

export const categories = ['All', 'Rolex', 'Patek Philippe', 'Audemars Piguet', 'Cartier']

